<template>
    <div class="header-bg">
        <div class="header-box">
            <div class="header-logo">
                <el-link
                href="/"
                target="_blank"
                :underline="false">
                    <img src="http://www.100ec.cn/Public/home/images/wjsLOGO.png">
                </el-link>
            </div>

            <div class="header-nav">
                <el-link
                v-for="(item, index) in nav"
                :key="index"
                :href="item.href"
                target="_blank"
                :underline="false">{{item.name}}</el-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            nav: [
                {
                    name: '首页',
                    href: '/'
                },
                {
                    name: '研究',
                    href: '/Index/dszx.html'
                },
                {
                    name: '数据',
                    href: '/Index/dsb_product.html'
                },
                {
                    name: '投诉',
                    href: '/Index/complain.html'
                },
                {
                    name: '融资',
                    href: '/Index/finance.html'
                },
                {
                    name: '战疫',
                    href: '/Index/needs.html'
                },
                {
                    name: '专题',
                    href: '/topic.html'
                },
                {
                    name: '导航',
                    href: '/dh.html'
                }
            ]
        }
    }
}
</script>

<style scoped>
.header-bg {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eee;
    box-shadow: 0 0 9.5px 0.5px rgb(49 87 163 / 13%);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    padding: 10px 0;
}

.header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: auto;
}

.header-logo img {
    height: 40px
}

.header-nav .el-link {
    padding: 0 10px;
}

@media(max-width: 1200px) {
    .header-box {
        display: initial;
    }

    .header-logo {
        text-align: center;
        padding-bottom: 10px;
    }

    .header-logo img {
        height: 32px;
    }

    .header-nav {
        display: flex;
        justify-content: space-around;
    }

    .header-nav .el-link {
        padding: 0;
    }
}
</style>
